import React from 'react';
import styled from 'styled-components/macro';

import RadioButton, { Wrapper as _RadioButton } from '../../common/components/svg/RadioButton';
import HandwriteCircle, { Wrapper as _HandwriteCircle } from '../../common/components/svg/HandwriteCircle';

export const Wrapper = styled.div`
  position: relative;
  margin-right: 25rem;

  ${_RadioButton} {
    position: relative;
    width: 12rem;
    min-width: 12rem;
  }

  ${_HandwriteCircle} {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-40%, -30%);
  
    height: 35rem;
    width: auto;
  }
`;

const CircledRadioButton = ({ index, active, onRadioClick }: {
  index: number,
  active: boolean,
  onRadioClick: (n: number) => void
}) => {
  return (
    <Wrapper>
      <HandwriteCircle
        active={active}
      />

      <RadioButton
        active={active}
        onClick={() => onRadioClick(index)}
      />
    </Wrapper>
  );
}

export default CircledRadioButton;